import React from "react";

export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/prospera-logo-transparent.png"
    width={size}
    height={size}
    alt="Prospera Staffing logo"
    className={className}
    style={{ objectFit: "contain" }}
  />
);

export const Logo = ({ dark = false, onClick, size = 38 }) => (
  <a
    href="#home"
    onClick={onClick}
    data-testid="logo-link"
    className="flex items-center gap-3 group select-none"
    aria-label="Prospera Staffing home"
  >
    <LogoMark size={size} className="transition-transform duration-500 group-hover:rotate-[-6deg]" />
    <span className="font-accent leading-none text-lg sm:text-xl tracking-wide">
      <span className="text-[#C62828] font-600" style={{ fontWeight: 700 }}>
        PROSPERA
      </span>{" "}
      <span
        className={dark ? "text-[#F7F7F5]" : "text-[#1F1F1F]"}
        style={{ fontWeight: 500 }}
      >
        STAFFING
      </span>
    </span>
  </a>
);

export default Logo;
